import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { Avatar, PopoverV2, Portal } from '@withjoy/joykit';
import { useIdentityWidget } from './useIdentityWidget';
import type { IdentityWidgetProps } from './IdentityWidget.types';
import { IdentityWidgetContent } from './components/IdentityWidgetContent';
import { ReactComponent as IconOptionSelectDown } from '@assets/icons/icon-option-select-down.svg';
import { StyledPillContainer, styles } from './IdentityWidget.styles';

export const IdentityWidget = ({ anchorProps, tabIndex, ...restProps }: IdentityWidgetProps & { anchorProps?: BoxProps; tabIndex: number }) => {
  const { isOpen, setIsOpen, popoverContentRef, openHandler, pillContainerRef } = useIdentityWidget();

  return (
    <PopoverV2
      showArrow={false}
      isOpen={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      closeOnOutsideClick
      placement="bottomEnd"
      overrides={{
        Root: { props: { zIndex: 'dropdown' } },
        Content: { props: styles.popoverContentProps },
        Body: { props: { ...styles.popoverBodyProps, ref: popoverContentRef } },
      }}
    >
      <PopoverV2.Trigger>
        <StyledPillContainer
          onKeyDown={(e: React.KeyboardEvent) => openHandler(e)}
          tabIndex={tabIndex}
          $isWidgetOpen={isOpen}
          {...anchorProps}
          ref={pillContainerRef}
          __css={styles.pillContainer}
        >
          <Avatar
            size="md"
            name={{ firstName: restProps.profile.firstName ?? undefined, lastName: restProps.profile.lastName ?? undefined }}
            src={restProps.profile.avatar?.url}
            overrides={{ Root: { props: { marginRight: 4 } } }}
          />
          <IconOptionSelectDown />
        </StyledPillContainer>
      </PopoverV2.Trigger>
      {/* Portaled: the menu hangs off the marcom nav bar, whose stacking context would clip it. */}
      <Portal>
        <PopoverV2.Content>
          <IdentityWidgetContent {...restProps} />
        </PopoverV2.Content>
      </Portal>
    </PopoverV2>
  );
};
